import { Locale } from 'date-fns';
import { es, enUS, fr } from 'date-fns/locale';

export interface Event {
    date: Date;
    title: string;
    color?: string;
}

export interface CalendarProps {
    selectedDate: Date;
    onChange: (date: Date) => void;
    maxDate?: Date;
    minDate?: Date;
    isRangeSelection?: boolean;
    startDate?: Date;
    endDate?: Date;
    onRangeChange?: (start: Date, end: Date) => void;
    events?: Event[];
    disabledDays?: Date[];
}

export const getDateFnsLocale = (language: string): Locale => {
    switch (language) {
        case 'es':
            return es;
        case 'fr':
            return fr;
        default:
            return enUS;
    }
};
